export const ChatLoadingIndicator: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  return (
    isLoading && (
      <div className='flex justify-center px-6 py-4'>
        <div className='flex items-center gap-2 text-sm text-gray-500'>
          <div className='size-4 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600'></div>
        </div>
      </div>
    )
  );
};
